import { render, staticRenderFns } from "./login.component.vue?vue&type=template&id=7060512a&scoped=true&"
import script from "./login.component.vue?vue&type=script&lang=js&"
export * from "./login.component.vue?vue&type=script&lang=js&"
import style0 from "./login.component.vue?vue&type=style&index=0&id=7060512a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7060512a",
  null
  
)

export default component.exports